<template>
    <footer class="linha">
        <div class="container">
            © Academia do Autismo 2019
        </div>
    </footer>
</template>

<script>
export default {
    name: 'rodape',
}
</script>

<style lang="scss">
    @import "./../assets/sass/rodape";
</style>

